import React from 'react';
import { DoubleCheck } from 'icons';
import { SvgIcon } from 'components';
import { SeenStyled } from './seen.styled';

interface SeenProps {
  short?: boolean;
  timestamp?: string;
}

// const convertTimestamp = (timestamp: string) => {
//   return new Date(timestamp).toLocaleString(undefined, {
//     day: 'numeric',
//     month: 'long',
//     hour: '2-digit',
//     minute: '2-digit',
//   });
// };

export const Seen = ({ short = true }: SeenProps) => {
  // let textElement = (
  //   <>Seen on &nbsp; {timestamp ? convertTimestamp(timestamp) : null}</>
  // );
  //

  let textElement = null;

  if (short) textElement = <>Seen</>;

  return (
    <SeenStyled>
      <SvgIcon icon={<DoubleCheck />} color='primary' size='small' />
      {textElement}
    </SeenStyled>
  );
};
